<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addReceivedSupplierOrderPosition></addReceivedSupplierOrderPosition>
    </v-dialog>
</template>

<script>
    import addReceivedSupplierOrderPosition from './AddWarehouseOrderPosition.vue'
    
    import {
        SupplierOrderPositionReceived
    } from '../../../store/namespace-helper'

    export default {
      name: 'AddWarehouseSupplierOrderPositionDialog',
      components: {
        addReceivedSupplierOrderPosition
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[SupplierOrderPositionReceived.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SupplierOrders/SupplierOrderPositions/AddWarehouseOrderPositionDialog.vue